import _implicitStylesheets from "./suggestionOption.css";
import _implicitScopedStylesheets from "./suggestionOption.scoped.css?scoped=true";
import _adsIcon from "ads/icon";
import {freezeTemplate, registerTemplate} from "lwc";
const stc0 = {
  "listed-suggestion": true
};
const stc1 = {
  slotAssignment: "end",
  classMap: {
    "magnifier-icon": true
  },
  props: {
    "symbol": "magnifier",
    "size": "small",
    "fill": "white"
  },
  key: 1
};
const stc2 = {
  classMap: {
    "suggestion-text": true
  },
  attrs: {
    "data-testid": "suggestion-text"
  },
  context: {
    lwc: {
      dom: "manual"
    }
  },
  key: 2
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element, h: api_element} = $api;
  return [api_element("div", {
    classMap: stc0,
    attrs: {
      "data-item": $cmp.suggestion.suggestedKeyword,
      "data-testid": "suggestion-option"
    },
    key: 0
  }, [api_custom_element("ads-icon", _adsIcon, stc1), api_element("span", stc2)])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-c2ddgasjql";
tmpl.legacyStylesheetToken = "undefined-_suggestionOption";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
